<div class="block-link">
    <div class="row no-gutter">
        <div class="col-content">
            <a target="_blank" href="http://khcn.hce.edu.vn/"><img src="assets/img/computer_edit.png" alt="" />
                <p>Hệ Thống Khoa Học Công Nghệ</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://htt.hce.edu.vn/elearning/"><img src="assets/img/global_telecom.png" alt="Trang tác nghiệp" />
                <p>Hệ Thống E-Learning</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://cuusinhvien.hce.edu.vn/"><img src="assets/img/st_20131009135222.png" alt="Trang Sinh Viên" />
                <p>Cổng Thông Tin Cựu Sinh Viên</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://lib.hce.edu.vn/?cat_id=105&tid=1"><img src="assets/img/contact_email.png" alt="Giáo Trình Điện Tử" />
                <p>Giáo Trình Điện Tử</p>
            </a>
        </div>

        <div class="col-content">
            <a target="_blank" href="http://thuvienso.hce.edu.vn/"><img src="assets/img/chart_pie_edit.png" alt="" />
                <p>Thư Viện Số</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://doms.hce.edu.vn/"><img src="assets/img/vanban_20141230091654.jpg" alt="" />
                <p>Quản Lý Văn Bản và Điều Hành</p>
            </a>
        </div>
        <div class="col-content sy-teacher-r1">
            <a target="_blank" href="http://thongtingiangvien.hce.edu.vn/"><img src="assets/img/globe_model.png" alt="Thư Viện Số" />
                <p>Hệ Thống Thông Tin Giảng Viên</p>
            </a>
        </div>
    </div>
    <div class="row no-gutter"> 
        <div class="col-content">
            <a target="_blank" href="http://esurvey.hce.edu.vn/"><img src="assets/img/chart_pie_edit (1).png" alt="Khảo Sát Trức Tuyến" />
                <p>Khảo Sát Trức Tuyến</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://esurvey.hce.edu.vn/"><img src="assets/img/qldh_20140217091946.jpg" alt="" />
                <p>Hệ Thống Thông Tin Quản Lý ĐHH</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://hueuni.edu.vn/cchc/"><img src="assets/img/cchc_20140217100406.jpg" alt="" />
                <p>Cải Cách Hành Chính - ĐHH</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://apps.hce.edu.vn:8081/CompareDocumentScanner/"><img src="assets/img/csdl_20140217101337.jpg" alt="" />
                <p>Ứng Dụng Phát Hiên Đạo Văn</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://jos.hueuni.edu.vn/index.php/TCKHDHH"><img src="assets/img/khcn_20140217102203.jpg" alt="" />
                <p>Tạp Chí Khoa Học - ĐHH</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://hueuni.edu.vn/qlvb/"><img src="assets/img/VB_20140217102441.jpg" alt="" />
                <p>Tra Cứu Cứu Văn Bản ĐHH</p>
            </a>
        </div>
        <div class="col-content">
            <a target="_blank" href="http://qlkh.hueuni.edu.vn/"><img src="assets/img/dtkh_20140221112626.jpg" alt="Thư Viện Điện Tử" />
                <p>Quản Lý Đề Tài Khoa Học ĐHH</p>
            </a>
        </div>
        <div class="col-content sy-teacher-r2">
            <a target="_blank" href="http://thongtingiangvien.hce.edu.vn/"><img src="assets/img/globe_model.png" alt="Thư Viện Số" />
                <p>Hệ Thống Thông Tin Giảng Viên</p>
            </a>
        </div>
    </div>
</div>